import { storageService } from 'framework/utils';
import { useBaseCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';

const useRoleService = () => {
  const { findAll: findAllFromApi } = useBaseCrudService({
    singleResourceUrl: '',
    listResourceUrl: '/roles-on-project',
    useService: useKernelApi,
  });

  const { getDataFromStorage } = storageService('roleOnProject', findAllFromApi, '1.0');

  return {
    findAll: getDataFromStorage,
  };
};

export default useRoleService;
